// extracted by mini-css-extract-plugin
export var active = "_jm-2";
export var recordingDot = "_jm-1";
export var recordingIndicator = "_jm-0";